globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.LimitlessPlugins = appCustomerSpace.LimitlessPlugins || {};
appCustomerSpace.LimitlessPlugins.Selects = appCustomerSpace.LimitlessPlugins.Selects || {};

appCustomerSpace.LimitlessPlugins.Selects.Single = (function(){

  Single.selector = '[data-plugin="limitless.selects.single"]';

  Single.init = function($html) {
    if($html.find(Single.selector).length) {
      if(!Single.matcher) {
        $.fn.select2.amd.require(['select2/diacritics'], function (DIACRITICS) {
          function stripDiacritics (text) {
            function match(a) {
              return DIACRITICS[a] || a;
            }

            return text.replace(/[^\u0000-\u007E]/g, match);
          }

          Single.matcher = function(term, text) {
            var original = stripDiacritics(text.text).toUpperCase();
            var term = stripDiacritics(term.term || '').toUpperCase();

            if ((new RegExp(term, 'gi')).test(original + (text.element.dataset.keywords || ''))) {
              return text;
            } else {
              return null;
            }
          }
        });
      }

      $html.find(Single.selector).each(function() {
        new Single($(this));
      });
    }
  }

  function Single($html) {
    this.$html = $html;
    this.init();
  }

  Single.prototype = {
    init: function(){
      var select = this,
      options = select.$html.data('plugin-options') || {},
      defaults = {
        placeholder: select.$html.attr('placeholder') || "",
        allowClear: select.$html.hasClass('allow-clear'),
      };

      if(options.search || options.ajax) {
        defaults.minimumResultsForSearch = 5;
        defaults.matcher = Single.matcher;
      } else {
        defaults.minimumResultsForSearch = Infinity;
      }

      if(options.ajax) {
        defaults.ajax = {
          url: options.ajax,
          dataType: 'json',
          delay: 250,
          data: function (params) {
            return {
              q: params.term,
              page: params.page
            };
          },
          processResults: function (data, params) {
            params.page = params.page || 1;
            return {
              results: data.results,
              pagination: {
                more: (params.page * 30) < data.total_count
              }
            };
          },
          cache: true
        }
        defaults.minimumInputLength = 1;
        //defaults.maximumSelectionLength = 1;
        defaults.escapeMarkup = function (markup) { return markup; }
        defaults.templateResult = function(data) {
          if (data.loading) return data.text;
          return data.html;
        }

        delete options.ajax
      }

      if (select.$html.hasClass("custom-options")) {
        defaults.templateResult = select.replaceOptionsHtml;
        defaults.templateSelection = select.replaceOptionsHtml;
        defaults.containerCssClass = "select2-custom-options";
      }

      select.$html.select2($.extend({}, defaults, options, true));
    },
    replaceOptionsHtml: function(option, container) {
      if (option.element && option.element.dataset.template) {
        var $option = $('<span>' + option.element.dataset.template + '</span>');
        return $option;
      } else {
        return option.text
      }
    }
  }

  return Single;
})();

appCustomerSpace.LimitlessPlugins.Selects.Multiple = (function () {
  Multiple.selector = '[data-plugin="limitless.selects.multiple"]';

  Multiple.init = function ($html) {
    $html.find(Multiple.selector).each(function () {
      new Multiple($(this));
    });
  };

  function Multiple($html) {
    var _this = this;

    this.$html = $html;
    this.$form = this.$html.closest("form");

    var multipleOptions = this.$html.data("multiple-options") || {};

    var multipleLabels = this.$html.data("multiple-labels") || {
      all_selected: "Tous les mots-clés",
      n_selected: "mots-clés sélectionnés",
      none_selected: "Aucune sélection",
    };

    this.settings = $.extend(
      {
        enableFiltering: true,
        includeSelectAllOption: true,
        selectAllText: multipleLabels.all_selected,
        buttonText: function (options, select) {
          if (options.length === 0) {
            return multipleLabels.none_selected;
          } else if (options.length === select[0].length) {
            return multipleLabels.all_selected;
          } else {
            return options.length + " " + multipleLabels.n_selected;
          }
        },
        onInitialized: function (select, container) {
          $(container).find("input").each(function () {
            $(this).uniform();
            $(this).parentsUntil("label.checkbox").parent().addClass("checkbox-primary");
          });
        },
        onSelectAll: function () {
          $.uniform.update();
        },
      },
      multipleOptions
    );

    this.init();
  }

  Multiple.prototype = {
    init: function () {
      this.$html.multiselect(this.settings);
    },
  };

  return Multiple;
})();
